import { useTranslate } from 'hooks/useTranslate';
import { FC, ChangeEvent } from 'react';

type Props = {
  pauseStartDate: string;
  pauseEndDate: string;
  handleChangePauseEndDate: (event: ChangeEvent<HTMLInputElement>) => void;
};

const UnpauseBeneficiaryDateSection: FC<Props> = ({
  pauseStartDate,
  pauseEndDate,
  handleChangePauseEndDate,
}) => {
  const { t } = useTranslate();

  return (
    <>
      <div className="form-group">
        <label className="form-label" htmlFor="start-pause-date">
          {t('StartPauseDate')}
        </label>
        <div className="form-control-wrap">
          <input
            type="date"
            className="form-control date-picker form-control-lg"
            id="start-pause-date"
            value={pauseStartDate}
            disabled
          />
        </div>
      </div>

      <div className="form-group">
        <label className="form-label" htmlFor="end-pause-date">
          {t('EndPauseDate')}
        </label>
        <div className="form-control-wrap">
          <input
            type="date"
            className="form-control date-picker form-control-lg"
            id="end-pause-date"
            value={pauseEndDate}
            onChange={handleChangePauseEndDate}
            min={pauseStartDate}
            max="2100-01-01"
          />
        </div>
      </div>

      <hr className="border-muted my-4" />
    </>
  );
};

export default UnpauseBeneficiaryDateSection;

